import { useContext } from 'react'
import { NotificationContext } from '../context'

export const useNotification = () => {
    const context = useContext(NotificationContext)
    if (!context) {
        throw new Error(
            'useNotification hook must be used within a NotificationProvider'
        )
    }
    return context
}
